import { getStore } from '../state/configure_store'

export const resolveAppVersion = () => {
  const store = getStore()
  const state = store?.getState()

  const stateAppVersion = state?.appInfo?.appVersion
  const fallbackAppVersion = '2.1.4'

  const appVersion = process.env.REACT_APP_APP_VERSION || stateAppVersion

  if (
    typeof appVersion !== 'string' ||
    appVersion.trim() !== appVersion ||
    !/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/.test(appVersion)
  ) {
    return fallbackAppVersion
  }

  return appVersion
}

export const resolveParamsForUrl = (url: string) => {
  const urlObj = new URL(url)
  const params = new URLSearchParams(urlObj.search)

  params.set('source', source)
  params.set('app_version', resolveAppVersion())

  urlObj.search = params.toString()

  return urlObj.toString()
}

export const source = process.env.REACT_APP_SOURCE || process.env.EXPO_PUBLIC_SOURCE || 'unknown'
